import $ from 'jquery'

export function sleep(numberMillis) {
  var now = new Date()
  var exitTime = now.getTime() + numberMillis
  var flag = 1
  while (flag < 2) {
    now = new Date()
    if (now.getTime() > exitTime) return
  }
}
export function $Url(url) {
  return new Promise(function(resolve, reject) {
    $.ajax({
      url,
      type: 'get',
      timeout: 6000,
      dataType: 'script',
      async: true,
      success: () => {
        resolve()
      },
      error: () => {
        reject()
      }
    })
  })
}

/**
 * 加载url
 * @param {*} url
 */
export function loadScript(url) {
  // https://stackoverflow.com/questions/16839698/jquery-getscript-alternative-in-native-javascript
  return new Promise(function(resolve, reject) {
    let newScript = document.createElement('script')
    newScript.onerror = reject
    newScript.onload = resolve
    document.currentScript.parentNode.insertBefore(newScript, undefined) //插入
    newScript.src = url
    newScript.remove() //删除script
  })
}

/**
 * 生成uuid
 */
export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
/**
 * 获取浏览器信息
 */
export function browserInfo() {
  var nVer = navigator.appVersion
  var nAgt = navigator.userAgent
  var browser = navigator.appName
  var version = '' + parseFloat(navigator.appVersion)
  var majorVersion = parseInt(navigator.appVersion, 10)
  var nameOffset, verOffset, ix
  // Opera
  if ((verOffset = nAgt.indexOf('Opera')) != -1) {
    browser = 'Opera'
    version = nAgt.substring(verOffset + 6)
    if ((verOffset = nAgt.indexOf('Version')) != -1) {
      version = nAgt.substring(verOffset + 8)
    }
  }
  // Opera Next
  if ((verOffset = nAgt.indexOf('OPR')) != -1) {
    browser = 'Opera'
    version = nAgt.substring(verOffset + 4)
  }
  // Edge
  else if ((verOffset = nAgt.indexOf('Edge')) != -1) {
    browser = 'Microsoft Edge'
    version = nAgt.substring(verOffset + 5)
  }
  // MSIE
  else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
    browser = 'Microsoft Internet Explorer'
    version = nAgt.substring(verOffset + 5)
  }
  // Chrome
  else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
    browser = 'Chrome'
    version = nAgt.substring(verOffset + 7)
  }
  // Safari
  else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
    browser = 'Safari'
    version = nAgt.substring(verOffset + 7)
    if ((verOffset = nAgt.indexOf('Version')) != -1) {
      version = nAgt.substring(verOffset + 8)
    }
  }
  // Firefox
  else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
    browser = 'Firefox'
    version = nAgt.substring(verOffset + 8)
  }
  // MSIE 11+
  else if (nAgt.indexOf('Trident/') != -1) {
    browser = 'Microsoft Internet Explorer'
    version = nAgt.substring(nAgt.indexOf('rv:') + 3)
  }
  // Other browsers
  else if (
    (nameOffset = nAgt.lastIndexOf(' ') + 1) <
    (verOffset = nAgt.lastIndexOf('/'))
  ) {
    browser = nAgt.substring(nameOffset, verOffset)
    version = nAgt.substring(verOffset + 1)
    if (browser.toLowerCase() == browser.toUpperCase()) {
      browser = navigator.appName
    }
  }
  // trim the version string
  if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix)
  if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix)
  if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix)

  majorVersion = parseInt('' + version, 10)
  if (isNaN(majorVersion)) {
    version = '' + parseFloat(navigator.appVersion)
    majorVersion = parseInt(navigator.appVersion, 10)
  }

  // mobile version
  var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer)

  return {
    browser,
    version,
    majorVersion,
    mobile
  }
}

/**
 * 获取系统信息
 */
export function OSInfo() {
  var nVer = navigator.appVersion
  var nAgt = navigator.userAgent
  var clientStrings = [
    { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
    { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
    { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
    { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
    { s: 'Windows Vista', r: /Windows NT 6.0/ },
    { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
    { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
    { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
    { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
    { s: 'Windows 98', r: /(Windows 98|Win98)/ },
    { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
    { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
    { s: 'Windows CE', r: /Windows CE/ },
    { s: 'Windows 3.11', r: /Win16/ },
    { s: 'Android', r: /Android/ },
    { s: 'Open BSD', r: /OpenBSD/ },
    { s: 'Sun OS', r: /SunOS/ },
    { s: 'Linux', r: /(Linux|X11)/ },
    { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
    { s: 'Mac OS X', r: /Mac OS X/ },
    { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
    { s: 'QNX', r: /QNX/ },
    { s: 'UNIX', r: /UNIX/ },
    { s: 'BeOS', r: /BeOS/ },
    { s: 'OS/2', r: /OS\/2/ },
    {
      s: 'Search Bot',
      r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
    }
  ]
  for (var id in clientStrings) {
    var cs = clientStrings[id]
    if (cs.r.test(nAgt)) {
      var os = cs.s
      break
    }
  }
  var osVersion = 'unknown'

  if (/Windows/.test(os)) {
    osVersion = /Windows (.*)/.exec(os)[1]
    os = 'Windows'
  }

  switch (os) {
    case 'Mac OS X':
      osVersion = /Mac OS X (10[._\d]+)/.exec(nAgt)[1]
      break

    case 'Android':
      osVersion = /Android ([._\d]+)/.exec(nAgt)[1]
      break

    case 'iOS':
      osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer)
      osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0)
      break
  }
  return {
    os,
    osVersion
  }
}

/**
 * 获取flashVersion
 */
export function getFlashVersion() {
  var hasFlash = 0 //是否安装了flash
  var flashVersion = 0 //flash版本
  var isValid = 0 //是否过期

  if (navigator.plugins && navigator.plugins.length > 0) {
    var swf = navigator.plugins['Shockwave Flash']
    if (swf) {
      hasFlash = 1
      isValid = 1
      var words = swf.description.split(' ')
      for (var i = 0; i < words.length; ++i) {
        if (isNaN(parseInt(words[i]))) continue
        flashVersion = parseInt(words[i])
      }
      if (swf.filename && swf.filename == 'internal-not-yet-present') {
        //过期
        isValid = 0
      }
    }
  }
  return { flash: hasFlash, version: flashVersion, vaild: isValid }
}

/**
 * Cookie状态
 */
export function getCookieEnable() {
  return document.cookie || navigator.cookieEnabled
}

export function checkScreen() {
  //检查浏览器分辨率
  var screenPixel = screen.width + '*' + screen.height
  var returnValue = screenPixel + ' ' + screen.colorDepth + '位色'
  return returnValue
}
